import React from "react";
import LaunchableInteractive from "components/Launchables/List/LaunchableInteractive";

interface LaunchableErrorLayoutProps {
  title: string;
  description: string;
  action?: React.ReactNode;
}

export const LaunchableErrorLayout: React.FC<LaunchableErrorLayoutProps> = ({
  title,
  description,
  action,
}) => {
  const titleId = `launchable-error-${title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")}`;

  return (
    <section
      className="flex min-h-[calc(100vh-var(--admin-navigation-top-offset,48px)-4rem)] flex-col items-center justify-center text-center sm:min-h-[calc(100vh-var(--admin-navigation-top-offset,48px)-5rem)]"
      aria-labelledby={titleId}
    >
      <div className="max-w-lg">
        <h1 id={titleId} className="text-xl font-bold text-white">
          {title}
        </h1>
        <p className="mt-2 text-sm font-semibold text-secondary">
          {description}
        </p>
        {action && <div className="mt-4">{action}</div>}
      </div>
      <div className="relative mt-6">
        <LaunchableInteractive
          isSectionInfoEnabled={false}
          isAnimationEnabled={true}
        />
      </div>
    </section>
  );
};
